import { render, staticRenderFns } from "./rightMenu.vue?vue&type=template&id=6cecda91&v-slot%3Adefault=%7B%20on%2C%20attrs%20%7D&"
import script from "./rightMenu.vue?vue&type=script&lang=js&"
export * from "./rightMenu.vue?vue&type=script&lang=js&"
import style0 from "./rightMenu.vue?vue&type=style&index=0&id=6cecda91&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports